import React from "react";
import { useTranslation } from "react-i18next";

function NotFoundError(props) {
  const { t } = useTranslation();
  return <p className="notificationText">{t("apiErrors.err404")}</p>;
}

export default NotFoundError;
